// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { HiSearch } from "react-icons/hi";
// import Pagination from "Components/Pagination/Pagination";
// import TableLoader from "Components/Common/Loader/TableLoader"; // ✅ import loader

// const AvailableGiftBalanceTable = () => {
//   const [users, setUsers] = useState([]);
//   const [pagination, setPagination] = useState({
//     page: 1,
//     limit: 10,
//     total: 0,
//     pages: 0,
//   });
//   const [loading, setLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [error, setError] = useState("");

//   const fetchAvailableBalances = async (page = 1, limit = 10, search = "") => {
//     setLoading(true);
//     setError("");
//     try {
//       const params = new URLSearchParams({ page, limit });
//       if (search) params.append("searchTerm", search);

//       const response = await axios.get(
//         `${
//           process.env.REACT_APP_API_URL
//         }/coin-withdrawal/get-available-balances?${params.toString()}`
//       );

//       const { data, pagination } = response.data;
//       setUsers(data || []);
//       setPagination(pagination || { page: 1, limit: 10, total: 0, pages: 0 });
//     } catch {
//       setError("Failed to load data. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAvailableBalances(pagination.page, pagination.limit, searchTerm);
//   }, [searchTerm]);

//   const handleSearchTerm = (value) => {
//     setTimeout(() => setSearchTerm(value), 800);
//   };

//   const totalPages = pagination.pages || 0;

//   return (
//     <div className="py-5">
//       <div className="rounded-2xl bg-white p-5 shadow-sm">
//         <h2 className="mb-4 text-lg font-semibold">
//           Available Gift Wallet Balances
//         </h2>

//         {/* Search Input */}
//         <div className="w-full md:mx-4 md:w-1/2 md:flex-1">
//           <div className="relative mb-4">
//             <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-500">
//               <HiSearch color="#c51369" className="h-5 w-5" />
//             </span>
//             <input
//               type="text"
//               placeholder="Search by number....."
//               className="block w-full rounded-md border px-4 py-2 pl-10 text-gray-700 focus:outline-none focus:ring-1 focus:ring-[#c51369] md:w-1/2"
//               onChange={(e) => handleSearchTerm(e.target.value)}
//             />
//           </div>
//         </div>

//         {loading ? (
//           <TableLoader />
//         ) : error ? (
//           <p className="text-red-500">{error}</p>
//         ) : (
//           <>
//             <div className="overflow-x-auto rounded-2xl">
//               <table className="w-full border text-left text-sm">
//                 <thead className="bg-[#e0ced7] text-gray-700">
//                   <tr className="text-center">
//                     <th className="border px-4 py-2">Avatar</th>
//                     <th className="border px-4 py-2">Full Name</th>
//                     <th className="border px-4 py-2">Phone</th>
//                     <th className="border px-4 py-2">Gift Wallet</th>
//                     <th className="border px-4 py-2">Current Location</th>
//                     <th className="border px-4 py-2">Preferred Language</th>
//                   </tr>
//                 </thead>
//                 <tbody className="text-center">
//                   {users.length > 0 ? (
//                     users.map((user) => (
//                       <tr key={user._id} className="border-b bg-white">
//                         <td className="border px-4 py-2 text-center">
//                           <div className="flex items-center justify-center">
//                             <img
//                               src={user?.selected_Avatar?.avatarUrl}
//                               alt="Avatar"
//                               className="h-10 w-10 rounded-full border border-gray-300 object-cover shadow-sm"
//                             />
//                           </div>
//                         </td>

//                         <td className="border px-4 py-2">
//                           {user.fullName || "N/A"}
//                         </td>
//                         <td className="border px-4 py-2">
//                           {user.phone || "N/A"}
//                         </td>
//                         <td className="border px-4 py-2 font-bold text-green-600">
//                           {user.giftWallet || 0}
//                         </td>
//                         <td className="border px-4 py-2">
//                           {user.current_Location || "N/A"}
//                         </td>
//                         <td className="border px-4 py-2">
//                           {user.preferred_Language || "N/A"}
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan="6" className="py-4 text-center">
//                         No records found.
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination */}
//             {totalPages > 1 && (
//               <Pagination
//                 currentPage={pagination.page}
//                 totalPages={totalPages}
//                 onPageChange={(page) =>
//                   fetchAvailableBalances(page, pagination.limit, searchTerm)
//                 }
//               />
//             )}
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AvailableGiftBalanceTable;

// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
import React, { useEffect, useState } from "react";
import axios from "axios";
import { HiSearch } from "react-icons/hi";
import { FaFileExcel } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Pagination from "Components/Pagination/Pagination";
import TableLoader from "Components/Common/Loader/TableLoader";
import exportToExcel from "../../utils/exportToExcel";
import Swal from "sweetalert2";

const AvailableGiftBalanceTable = () => {
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    pages: 0,
  });
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [filter, setFilter] = useState("select");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [error, setError] = useState("");
  const [minWallet, setMinWallet] = useState("");
  const [maxWallet, setMaxWallet] = useState("");

  // 🔹 Debounce Search Input
  useEffect(() => {
    const delay = setTimeout(() => setDebouncedSearch(searchTerm), 500);
    return () => clearTimeout(delay);
  }, [searchTerm]);

  // 🔹 Fetch Available Balances
  const fetchAvailableBalances = async (
    page = 1,
    limit = 10,
    exportAll = false
  ) => {
    try {
      if (exportAll) {
        Swal.fire({
          title: "Preparing Export...",
          text: "Fetching all data, please wait...",
          allowOutsideClick: false,
          didOpen: () => Swal.showLoading(),
        });
      } else {
        setLoading(true);
      }

      const params = {
        page: exportAll ? 1 : page,
        limit: exportAll ? "all" : limit,
        filter,
        searchTerm: debouncedSearch || undefined,
        exportAll: exportAll || undefined,
        ...(filter === "custom" && startDate && endDate
          ? {
              startDate: startDate.toISOString(),
              endDate: endDate.toISOString(),
            }
          : {}),
        ...(filter === "walletRange" && minWallet && maxWallet
          ? {
              minWallet: Number(minWallet),
              maxWallet: Number(maxWallet),
            }
          : {}),
      };

      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/coin-withdrawal/get-available-balances`,
        { params }
      );

      const records = data?.data || [];

      // ⚠️ Handle No Data (Export Only)
      if (!records.length) {
        if (exportAll) {
          await Swal.fire({
            icon: "warning",
            title: "No Data Found",
            text: "There is no data available to export.",
            showConfirmButton: true,
            allowOutsideClick: false,
          });
        }
        setUsers([]);
        setPagination({ page: 1, limit: 10, pages: 0 });
        return;
      }

      // ✅ Handle Export Success
      if (exportAll) {
        Swal.close();
        exportToExcel(records, "AvailableGiftWalletReport");
        await Swal.fire({
          icon: "success",
          title: "Export Complete!",
          text: "AvailableGiftWalletReport.xlsx downloaded successfully.",
          showConfirmButton: true,
          allowOutsideClick: false,
        });
      } else {
        // Normal data load
        setUsers(records);
        setPagination(data.pagination || {});
      }
    } catch (err) {
      console.error(err);
      setError("Failed to load data. Please try again.");
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong. Please try again.",
        showConfirmButton: true,
        allowOutsideClick: false,
      });
    } finally {
      if (!exportAll) Swal.close(); // only close loader for normal fetch
      setLoading(false);
    }
  };

  // 🔹 Filter Change
  const handleFilterChange = (value) => {
    setFilter(value);
    setPagination((prev) => ({ ...prev, page: 1 }));

    // Reset dates when not using custom
    if (value !== "custom") {
      setStartDate(null);
      setEndDate(null);
    }

    // Reset wallet range when not using walletRange
    if (value !== "walletRange") {
      setMinWallet("");
      setMaxWallet("");
    }
  };

  useEffect(() => {
    fetchAvailableBalances(1, pagination.limit);
  }, [debouncedSearch, filter, startDate, endDate, minWallet, maxWallet]);

  // 🔹 Export All Handler
  const handleExport = async () => {
    try {
      // 🔹 Show loading modal
      Swal.fire({
        title: "Preparing Export...",
        text: "Fetching all data, please wait...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      // 🔹 Fetch all data (no pagination)
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/coin-withdrawal/get-available-balances`,
        {
          params: {
            exportAll: true,
            filter,
            searchTerm: debouncedSearch || undefined,
            ...(filter === "custom" && startDate && endDate
              ? {
                  startDate: startDate.toISOString(),
                  endDate: endDate.toISOString(),
                }
              : {}),
            ...(filter === "walletRange" && minWallet && maxWallet
              ? {
                  minWallet: Number(minWallet),
                  maxWallet: Number(maxWallet),
                }
              : {}),
          },
        }
      );

      const records = data?.data || [];

      // ⚠️ No data found
      if (!records.length) {
        Swal.close();
        await Swal.fire({
          icon: "warning",
          title: "No Data Found",
          text: "There is no data available to export.",
          showConfirmButton: true,
          allowOutsideClick: false,
        });
        return;
      }

      // ✅ Format export data (only table fields)
      const exportData = records.map((user, index) => ({
        // "Sl. No.": index + 1,
        "Full Name": user.fullName || "--",
        Phone: user.phone ? user.phone.slice(2) : "--",
        "Preferred Language": user.preferred_Language || "--",
        Date: new Date(user.createdAt).toLocaleDateString(),
        Time: new Date(user.createdAt).toLocaleTimeString(),
        Coins: user.coinAmount || 0,
        "Gift Wallet": user.giftWallet || 0,
        "Wallet Balance (₹)": Number(user.convertedWallet)?.toFixed(3) || 0,
      }));

      // ✅ Close loading, export, then show success modal
      Swal.close();
      exportToExcel(exportData, "AvailableGiftWalletReport");

      await Swal.fire({
        icon: "success",
        title: "Export Complete!",
        text: "AvailableGiftWalletReport.xlsx downloaded successfully.",
        showConfirmButton: true,
        allowOutsideClick: false,
      });
    } catch (err) {
      console.error(err);
      Swal.close();
      await Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "Something went wrong. Please try again.",
        showCloseButton: true,
        allowOutsideClick: false,
      });
    }
  };

  return (
    <div className="py-5">
      <div className="rounded-2xl bg-white p-5 shadow-sm">
        <h2 className="mb-4 text-lg font-semibold">
          Available Gift Wallet Balances
        </h2>

        {/* 🔹 Filters Section */}
        <div className="mb-4 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div className="flex w-full flex-col gap-3 md:flex-row md:items-center md:gap-3">
            {/* Search */}
            <div className="relative w-full md:w-1/3">
              <HiSearch className="absolute left-3 top-2.5 text-gray-500" />
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full rounded-md border px-10 py-2 focus:outline-none focus:ring-1 focus:ring-[#c51369]"
              />
            </div>

            {/* Filters */}
            <div className="flex flex-wrap items-center gap-2 md:gap-3">
              <select
                value={filter}
                onChange={(e) => handleFilterChange(e.target.value)}
                className="rounded-md border px-4 py-2 text-sm focus:ring-1 focus:ring-[#c51369]"
              >
                <option value="select">Select Filter</option>
                <option value="all">All</option>
                <option value="today">Today</option>
                <option value="last7days">Last 7 Days</option>
                <option value="custom">Custom Date</option>
                <option value="walletRange">Balance Range</option>
              </select>

              {filter === "custom" && (
                <div className="flex items-center gap-2">
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    placeholderText="Start Date"
                    dateFormat="dd/MM/yyyy"
                    className="rounded-md border px-3 py-2 text-sm"
                  />
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    placeholderText="End Date"
                    dateFormat="dd/MM/yyyy"
                    className="rounded-md border px-3 py-2 text-sm"
                  />
                </div>
              )}

              {filter === "walletRange" && (
                <div className="flex items-center gap-2">
                  <input
                    type="number"
                    min="0"
                    value={minWallet}
                    onChange={(e) => {
                      const value = Math.max(0, e.target.value);
                      setMinWallet(value);
                    }}
                    placeholder="Min Wallet"
                    className="w-28 rounded-md border px-3 py-2 text-sm"
                  />
                  <input
                    type="number"
                    min="0"
                    value={maxWallet}
                    onChange={(e) => {
                      const value = Math.max(0, e.target.value);
                      setMaxWallet(value);
                    }}
                    placeholder="Max Wallet"
                    className="w-28 rounded-md border px-3 py-2 text-sm"
                  />
                </div>
              )}
            </div>
          </div>

          {/* Export Button */}
          <button
            onClick={handleExport}
            className="flex w-full items-center justify-center gap-2 rounded-md bg-[#c51369] px-4 py-2 text-sm text-white hover:bg-[#a01052] md:w-auto"
          >
            <FaFileExcel className="text-lg" /> Export
          </button>
        </div>

        {/* 🔹 Table Section */}
        {loading ? (
          <TableLoader />
        ) : error ? (
          <p className="text-red-500">{error}</p>
        ) : (
          <>
            <div className="overflow-x-auto rounded-2xl">
              <table className="w-full border text-left text-sm">
                <thead className="bg-[#e0ced7] text-gray-700">
                  <tr className="text-center">
                    <th className="border px-4 py-2">Sl. no.</th>
                    <th className="border px-4 py-2">User</th>
                    <th className="border px-4 py-2">Date & Time</th>
                    <th className="border px-4 py-2">Coins</th>
                    <th className="border px-4 py-2">Gift Wallet</th>
                    <th className="border px-4 py-2">Wallet Balance</th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  {users.length > 0 ? (
                    users.map((user, index) => (
                      <tr
                        key={user._id}
                        className="border-b bg-white text-center"
                      >
                        <td className="border px-4 py-2">{index + 1}</td>
                        <td className="justify-left flex w-full items-center gap-6 px-4  py-2 text-left ">
                          {/* 1️⃣ Image Section */}
                          <div className="flex-shrink-0  ">
                            <img
                              src={user?.selected_Avatar?.avatarUrl}
                              alt="avatar"
                              className="h-10 w-10 rounded-full border object-cover"
                            />
                          </div>

                          {/* 2️⃣ Text Info Section */}
                          <div className="flex flex-col  gap-1  ">
                            <span className="font-semibold capitalize text-gray-800">
                              {user?.fullName || "--"}
                            </span>
                            <span className="text-sm text-gray-700">
                              {user?.phone ? user.phone.slice(2) : "--"}
                            </span>
                            <span className="text-sm text-gray-700">
                              {user.preferred_Language || "--"}
                            </span>
                          </div>
                        </td>

                        <td className="border px-6 py-4 text-gray-700">
                          {new Date(user.createdAt).toLocaleDateString()} <br />
                          {new Date(user.createdAt).toLocaleTimeString()}
                        </td>
                        <td className="border px-4 py-2 text-gray-700">
                          {user.coinAmount || 0}
                        </td>
                        <td className="border px-4 py-2 text-gray-700">
                          {user.giftWallet || 0}
                        </td>
                        <td className="border px-4 py-2 font-bold text-green-600">
                          {Number(user.convertedWallet)?.toFixed(3) || 0}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="py-4 text-center">
                        No records found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {pagination.pages > 1 && (
              <Pagination
                currentPage={pagination.page}
                totalPages={pagination.pages}
                onPageChange={(page) =>
                  fetchAvailableBalances(page, pagination.limit)
                }
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default AvailableGiftBalanceTable;
